/** Clave pública VAPID (la privada vive en el backend). Compartida por negocios y superadmin. */
export const VAPID_PUBLIC_KEY = 'BAYOOdZx8_FLyZJvOyJMqJJMSnft58pwJ50jeFD0KPFtxNjyRiLmdQ__GiyPQpRtl1CjnEOBZJpTKNichshyC0w';

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}
